import React from 'react';
import { Chip } from '@mui/material';

// Chip de classement (or / argent / bronze / gris) utilisé dans les tableaux
// et les cards de StatsResults / MedidasResults.
const PlayerRankingChip = ({ ranking, size = 'small', sx = {} }) => {
  if (ranking == null) return null;

  const palette = {
    1: { bg: '#FFD700', fg: '#000' },
    2: { bg: '#C0C0C0', fg: '#000' },
    3: { bg: '#CD7F32', fg: '#000' },
  };
  const colors = palette[ranking] || { bg: '#e0e0e0', fg: '#666' };

  return (
    <Chip
      label={ranking}
      size={size}
      sx={{
        fontSize: '0.65rem',
        fontWeight: 700,
        minWidth: '25px',
        height: '20px',
        backgroundColor: colors.bg,
        color: colors.fg,
        '& .MuiChip-label': { padding: '0 4px' },
        ...sx,
      }}
    />
  );
};

export default PlayerRankingChip;
